import { render, staticRenderFns } from "./PopularQuestions.vue?vue&type=template&id=0c911672&scoped=true"
import script from "./PopularQuestions.vue?vue&type=script&lang=ts"
export * from "./PopularQuestions.vue?vue&type=script&lang=ts"
import style0 from "./PopularQuestions.vue?vue&type=style&index=0&id=0c911672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c911672",
  null
  
)

export default component.exports